import {BaseModel} from '@/core/standard/BaseModel';
import {BookingProtocol, IBookingModel, IBookings} from '@/modules/bookings/IBookingModel';
import BookingService from '@/modules/bookings/BookingService';
import ShiftService from '@/modules/shifts/ShiftService';


const booking = {
  date: '',
  qty_person: '',
  shift: '',
  client: '',
  options: [],
  observations: '',
};

class BookingModel extends BaseModel<IBookingModel, BookingProtocol> {
  public modelName = 'Turno';

  public request = 'JSON';

  constructor() {
    super(booking, BookingService);
  }

  public async getShiftInterval(toast, toastConfig) {
    const response = await ShiftService.getInterval();
    if (response.complete) {
      return this.handleSuccess(response.data, response.message, toast, toastConfig);
    }
    this.handleError(response, toast, toastConfig);
    return false;

  }

  public async save(toast: any, toastConfig: any): Promise<any> {
    (this as this & IBookingModel).options.forEach((option: any) => {
      if (!Array.isArray(option.answers)) {
        option.answers = [option.answers];
      }
    });
    return super.save(toast, toastConfig);
  }
}

export default BookingModel as new() => IBookings;


export class DailyBookingsModel {
  
  bookings: any[];
  bookingsBackup: any[];

  constructor() {
    this.bookings = [];
    this.bookingsBackup = [];
  }

  createBookings(data) {
    this.bookings = [];
    this.bookingsBackup = [];
    this.bookings.push(...data);
    this.bookingsBackup.push(...data);
  }

  sortBookings() {
    this.bookings.sort((a, b) => a.shift.start_at.localeCompare(b.shift.start_at));
  }

  getShifts(): {text: string; value: string}[] {
    let tempShifts: {text: string; value: string}[] = [];
    
    this.bookings.forEach((booking) => {
      let shiftValue = booking.shift.start_at.slice(0, 5);
      if (!tempShifts.find(shift => shift.value === shiftValue)) {
        tempShifts.push({text: shiftValue, value: shiftValue});
      }
    });
    return tempShifts;
  }

  filterByShift(shift: string): void{
    this.bookings = [...this.bookingsBackup];
    this.sortBookings();
    if(shift === 'all')  return;

    this.bookings = this.bookings.filter((booking) => booking.shift.start_at.slice(0, 5) === shift);
  }
}